module.exports = __webpack_public_path__ + "static/media/users.f8fe7f8e.svg";